const camelToSnake = c => c.replace(/[A-Z]/g, c => `-${c.toLowerCase()}`);
const snakeToCamel = s => s.replace(/-[a-z]/g, s => s.charAt(1).toUpperCase());


function dropUnmatched(key, value) {
  const query = `[data-status-${key}]`;

  Array.from(document.body.querySelectorAll(query))
    .forEach(function(el) {
      const dataKey = snakeToCamel(`status-${key}`);
      const values = el.dataset[dataKey].split('|');
      if (!values.includes(value)) { el.remove(); }
    });
}


function interpretStatuses(statuses) {
  Object.entries(statuses).forEach(([k, v]) => dropUnmatched(k, v));
}


export { interpretStatuses };
